export const GettingStartedImportModusIcons = `
{/* Include the following references in your index.html*/}

<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@trimble-oss/modus-icons/dist/modus-solid/fonts/modus-icons.css">
`

export const GettingStartedImportCSS = `
// for light mode
import '@trimbleinc/modus-react-bootstrap/css/dist/modus-react-bootstrap.min.css';

// for dark mode
import '@trimbleinc/modus-react-bootstrap/css/dist/modus-react-bootstrap-dark.min.css';

`

export const GettingStartedImportModusReactBootstrap = `
import Button from '@trimbleinc/modus-react-bootstrap/Button';

// or less ideally
import {Button} from '@trimbleinc/modus-react-bootstrap';
`
